import { skipToken, useQuery, type QueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getCustomerOrder,
  type OrderDetail as Order,
} from '@hungryroot/rest/api/v2/customers/[id]/orders/[order_id]/get';

const getOrderQueryKey = (orderId?: number) => [
  'Orders',
  'bundle order',
  orderId,
];

export async function invalidateOrders(queryClient: QueryClient) {
  await queryClient.invalidateQueries({
    queryKey: ['Orders'],
  });
}

/**
 * @deprecated - use useGetOrder from @hungryroot/order-details instead
 *
 * Warning!!!!!
 *
 * This hook has a side effect of triggering a shuffle on the order that you're fetching if the order isn't already shuffled.
 *
 * This can lead to side effects of shuffling an order too early, like when we're still collecting onboarding information.
 *
 * Be very careful about where you use this hook and, if you do use it, regression test the onboarding flow.
 */
export function useGetOrder(
  orderId?: number,
  options?: {
    enabled?: boolean;
    refetchInterval?: Parameters<typeof useQuery<Order>>[0]['refetchInterval'];
  }
) {
  const timeLimit = 5 * 60 * 1000;
  const { ...queryOptions } = options || {};

  return useQuery({
    queryKey: getOrderQueryKey(orderId),
    queryFn: orderId
      ? async () => {
          const resp = await getCustomerOrder({
            orderId,
          });

          if (resp.status !== StatusCode.SuccessOK) {
            throw new Error(JSON.stringify(resp.data, null, 2));
          }

          return resp.data;
        }
      : skipToken,
    ...queryOptions,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
